import { Box, Flex, Highlight, ScrollArea, Text } from '@mantine/core';
import { useState } from 'react';
import { Route, Switch } from 'wouter';
import Link from '@/components/Link';
import Search, { TItemRendererProps } from '@/components/search/Search';
import Contact from '@/contacts/Contact';
import { MondayItem } from '@/types';

function ItemRenderer({ item, term }: TItemRendererProps) {
  return (
    <>
      <Highlight highlight={term}>{item.name}</Highlight>
      <Highlight highlight={term} size="sm" m={0} c="gray.6">
        {item.column_values?.find((v) => v.id === 'contact_email')?.text ||
          'no email specified'}
      </Highlight>
    </>
  );
}

export default function Contacts() {
  const [recents, setRecents] = useState<MondayItem[]>([]);
  return (
    <Flex direction="column">
      <Search
        placeholder="Search contact by name or email"
        endpoint="contact/search"
        ItemRenderer={ItemRenderer}
        onRecentsLoaded={setRecents}
      />
      <Flex dir="column">
        <ScrollArea
          w="auto"
          flex="1"
          h="calc(100vh - var(--app-shell-header-height, 0px) - 76px)"
        >
          <Switch>
            <Route path={'/:id'} component={Contact} nest />
            <Route>
              <>
                <Box p="md">
                  <Text>Last visited contacts:</Text>
                  {recents.map((r) => (
                    <Link key={r.id} to={`/${r.id}`} pr="md">
                      {r.name}
                    </Link>
                  ))}
                </Box>
                <Text px="md">
                  Please use the search filed above to naviagte to desired
                  contact.
                </Text>
              </>
            </Route>
          </Switch>
        </ScrollArea>
      </Flex>
    </Flex>
  );
}
